module.exports = __webpack_public_path__ + "media/images/gallery/constellations/sextans/sex_names-315ce7741acb028c36a5e316332dfecf.gif";